export function StudioHost() {
  return (
    <main className="tool-host">
      <iframe
        className="runtime-frame"
        src="/runtime/asset-studio-v022.html?unified=1&readability=large-v1&catalog=device-art-v3&background-upload=v1"
        title="MatterMaze Asset Studio"
      />
    </main>
  );
}
